<template>
  <div class="users-list">
    <el-table
        :data="coldUsers"
        style="width: 100%; "
        @sort-change="sort"
        @filter-change="filterChange">
      <el-table-column
          label="Network"
          min-width="200"
          sortable
          prop="network_group"
          column-key="network"
          :filters="networkGroupsFilter"
      >
        <template slot-scope="scope">
          <span>{{ getNetworkName(scope.row.data.network_group)  }}</span>
        </template>
      </el-table-column>

      <el-table-column  prop="customer_full_name">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Customer Name"
              :status-sort="sortBy"
              sort-key="customer_full_name"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.customer.name }}
        </template>
      </el-table-column>

      <el-table-column  prop="customer_email">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Customer E-mail"
              :status-sort="sortBy"
              sort-key="customer_email"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.customer.email }}
        </template>
      </el-table-column>

      <el-table-column  prop="partner_full_name">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Partner Name"
              :status-sort="sortBy"
              sort-key="partner_full_name"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.partner.name }}
        </template>
      </el-table-column>

      <el-table-column  prop="partner_email">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Partner E-mail"
              :status-sort="sortBy"
              sort-key="partner_email"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.partner.email }}
        </template>
      </el-table-column>

      <el-table-column  prop="created_at">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Created At"
              :status-sort="sortBy"
              sort-key="created_at"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>


    </el-table>
    <div class="pagin-wrp">
      <el-pagination
          :background="true"
          layout="prev, pager, next"
          :page-size="1"
          @current-change="chosePage"
          :total="coldMeta.last_page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>

import HeaderSortTitle from '../UsersList/HeaderSortTitle'
import {mapGetters} from "vuex";

export default {
  name: "ColdTableList",
  components: {
    HeaderSortTitle,
  },
  props: {
    pageLabel: String,
    filterProps: {},
    countUser: Number,
    filterUser: String,
  },
  data () {
    return {
      chosenPage: 1,
      sortBy: {
        customer_full_name: 0,
        customer_email:0,
        partner_full_name: 0,
        partner_email: 0,
        created_at: 0,
      },
      filterBlock:this.filterProps,
    }
  },
  computed: {
    ...mapGetters({
      coldUsers: 'users/coldUsers',
      coldMeta: 'users/coldMeta',
      searchParams: 'users/searchParams',
      formatData: 'formatData/getFormates',
      networkGroupsFilter: 'networks/getNetworkGroupsFilter',
      networkGroups: 'networks/getNetworkGroups',
    }),
  },
  methods: {
    getNetworkName(networkGroup) {
      let filterGroup = {};
      filterGroup = this.networkGroups.find((obj)=>{  return obj.id===Number(networkGroup)});

      if ('name' in Object(filterGroup)){
        return filterGroup.name;
      }else{
        return '';
      }
    },
    filterChange(filter) {
      this.filterBlock = filter
      this.$emit('updateContent',  this.filterBlock)
      this.updateColdUserList()
    },
    chosePage (e) {
      this.chosenPage = e
      this.updateColdUserList()
    },

    sort(by) {
      let key  = (typeof by ==="object") ? by.prop : by

      if (this.sortBy[key] === 0) {
        this.sortBy[key] = 1
      } else if (this.sortBy[key] === 1) {
        this.sortBy[key] = -1
      } else if (this.sortBy[key] === -1) {
        this.sortBy[key] = 0
      }
      if(typeof by ==="object" && by.order==null){
        this.sortBy[key] = 0
      }
      this.updateColdUserList()
    },

    updateColdUserList() {
      let params = 'sort='
      if (this.sortBy) {
        for (let itm in this.sortBy) {
          if (this.sortBy[itm] === 1) {
            params = `${params}${itm},`
          } else if (this.sortBy[itm] === -1) {
            params = `${params}-${itm},`
          }
        }
      }
      if (params === 'sort=') {
        params = ''
      }
      params = `${params}&page=${this.chosenPage}`
      if (this.countUser) {
        params = `${params}&per_page=${this.countUser}`
      }
      if (this.filterUser.length) {
        params = `${params}&filter=${this.filterUser}`
      }
      if(this.pageLabel) {
        params = `${params}`
      }
      if (typeof this.filterBlock != 'undefined' && Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if(value.length === 0){
            return;
          }
          params = `${params}&${key}=`+JSON.stringify(value)
        });
      }
      this.$store.dispatch('users/getColdUsers', params)
    },

  },
  created () {
    this.updateColdUserList()
    if(!this.getFormates){
      this.$store.dispatch('formatData/getFormatData')
    }
    this.$store.dispatch('networks/networkGroups')
  },
  watch:{
    countUser(){
      this.updateColdUserList()
    },
    filterUser(){
      this.chosenPage = 1
      this.updateColdUserList()
    }
  }
}
</script>

